import React, { ReactElement } from 'react';
import Accordion from '../components/accordion';
import Separator from '../components/separator';
import { Link } from '@material-ui/core';

function LeftPanel(): ReactElement {
  const config = PW.config.leftPanel;

  return (
    <div className="left-panel">
      <h1 className="padded" style={{ marginBottom: 0 }}>
        POTTERWARE 4.0
      </h1>
      <p className="padded" style={{ marginTop: 4 }}>
        Brought to you by{' '}
        <Link href="/" color="inherit" underline="always">
          Emerging Objects
        </Link>
      </p>
      <Separator />
      <h3 className="padded">TOOLS</h3>
      <div className="left-panel--tools">
        <Accordion sections={config} />
      </div>
    </div>
  );
}

export default LeftPanel;
